module.exports = __webpack_public_path__ + "img/trevor-walker.8af244a7.jpeg";